<div class="text-grey-400 s-full body-2 {{ bgColor }} text-400 radius-4 fx-col fx-center fx-gap-2 p-3 border-box fx-justify-around">
  <span class="tw-text-sm tw-font-medium text-center">{{ key }}</span>
  <ngx-copy-to-clipboard
    *ngIf="value && copyToClipboard; else simple"
    class="w-full"
    position="right"
    copiedTooltip="Copied"
    tooltip="Click to copy"
    [textToCopy]="value">
    <span class="ellipsed w-full tw-text-base tw-font-normal text-center">
      {{ value }}
    </span>
  </ngx-copy-to-clipboard>

  <ng-template #simple>
    <span class="tw-text-base tw-font-normal text-center">{{ value }}</span>
  </ng-template>
</div>
